import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import { getDeviceId } from 'src/common/device/device';
import { getSessionId } from 'src/common/session/session';
import { v4 as uuid } from 'uuid';

const uri = process.env.GATSBY_GRAPHQL_API_URL;
const requestHeadersLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'x-request-id': uuid(),
      'x-session-id': getSessionId(),
      'x-device-id': getDeviceId(),
    },
  }));

  return forward(operation);
});

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: requestHeadersLink.concat(new HttpLink({ uri })),
  ssrMode: typeof window === 'undefined',
});
